export enum InternalActivityTypeEnum {
    MEETING = 1,
    INTERNAL_TRAINING = 2,
    MEDICAL_VISIT = 3,
    ANNUAL_EVALUATION_INTERVIEW = 4,
    OTHERS = 5,
}
